<template>
    <div>
        <li class="m-cell-tab">
            <ul class="m-cell-ptab">
                <li v-for="(title,index) in titles" :key="index">{{title}}</li>
            </ul>
            <p style="clear:both;"></p>
            <div>
                <div class="m-cell-tab-unit m-cell-tab-unit-left">
                    <p class="m-cell-tab-unit-title" v-for="(colName,index) in columnNames" :key="index">{{colName}}</p>
                </div>
                <div class="m-cell-tab-unit m-cell-tab-unit-middle">
                    <p class="m-cell-tab-unit-content" v-for="(count,index) in counts" :key="index"><span>{{count}}</span></p>
                </div>
                <div class="m-cell-tab-unit m-cell-tab-unit-right">
                    <p class="m-cell-tab-unit-content" v-for="(value,index) in values" :key="index"><span>{{value}}</span><label>{{currency}}</label></p>
                </div>
            </div>
        </li>
    </div>
</template>

<script>
export default {
name: "amountSummary",
    props:{
        titles:{
            type:Array,
            default: () => { return []}
        },
        columnNames:{
            type:Array,
            default: () => { return ['Alipay','WeChat Pay','Credit Card','Paypal','Debit Card','Unionpay','Venmo']} 
        },
        counts:{
            type:Array,
            default: () => { return []}
        },
        values:{
            type:Array,
            default: () => { return []}
        },
        currency:{
            type:String,
            default:''
        },

    },
    data(){
        return{

        }
    }
}
</script>

<style  scoped>
 
.m-cell-tab .m-cell-ptab{
    height: 60px;
    line-height: 60px;
    /* color: #FFF; */
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    overflow: hidden; 
    /* background: rgb(38, 162, 255); */
}
</style>


// WEBPACK FOOTER //
// src/views/main_components/amountSummary.vue